import { css } from 'styled-components';
import token from 'styled-token';
import { buttonResetMixin } from '../buttonResetMixin';
import { disabledMixin } from '../disabledMixin';
import { focusMixin } from '../focusMixin';
import { hoverMediaQueryMixin } from '../hoverMediaQueryMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';

/** @class TextButtonMixin */
/** @method */
export var TextButtonMixin = function TextButtonMixin(props) {
  var buttonType = props.buttonType,
    fontType = props.fontType,
    inverse = props.inverse;
  var variant = inverse ? 'Inverse' : buttonType.charAt(0).toUpperCase() + buttonType.slice(1);
  return token({
    color: "TextButton.fontColor" + variant,
    colorHover: "TextButton.fontColor" + variant + "Hover",
    colorPressed: "TextButton.fontColor" + variant + "Pressed"
  }, function (_ref) {
    var color = _ref.color,
      colorHover = _ref.colorHover,
      colorPressed = _ref.colorPressed;
    return css(["", " display:inline-flex;align-items:center;justify-content:center;&{text-decoration:", ";}&:active{text-decoration:", ";}&{color:", ";}&:hover{color:", ";}&:active{color:", ";}&:not(:active){", ";}", " ", " ", " ", ""], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), inverse ? 'underline' : 'none', inverse ? 'none' : 'underline', color, colorHover, colorPressed, hoverMediaQueryMixin("\n            text-decoration: " + (inverse ? 'none' : 'underline') + ";\n        "), focusMixin(props), buttonResetMixin(props), disabledMixin(props), spacingMixin(props));
  })(props);
};